const CHANNEL_DISPLAY_NAMES: Record<string, string> = {
  ZID: 'Zid',
  SALLA: 'Salla',
  AMAZON: 'Amazon',
  TRENDYOL: 'Trendyol',
  NOON: 'Noon',
}

export function channelDisplayName(value: string): string {
  const normalized = value.trim().toUpperCase()
  return CHANNEL_DISPLAY_NAMES[normalized] ?? value
}
